import React from "react"
import { makeStyles } from "@material-ui/styles"
import Typography from "@material-ui/core/Typography"
import { Grid, RichDescription, RichTitle } from ".."
import Img from "gatsby-image"

const useStyles = makeStyles(theme => {
  return {
    root: props => ({
      background: props.color
        ? theme.palette[props.color] && theme.palette[props.color].support
          ? theme.palette[props.color].supportLightBackground ||
            theme.palette[props.color].support
          : props.color
        : theme.palette.green.support,
      display: "flex",
      flexDirection:
        props.mediaPosition && props.mediaPosition === "Left"
          ? "row-reverse"
          : "row",
      height: 640,
      position: "relative",
      zIndex: 0,
      [theme.breakpoints.down("md")]: {
        height: "100%",
        maxHeight: "none",
        minHeight: 0,
      },
    }),
    grid: {
      height: "100%",
      overflow: "visible",
      [theme.breakpoints.down("md")]: {
        flexWrap: "wrap-reverse",
      },
    },
    copy: props => ({
      alignItems: "flex-start",
      position: "relative",
      display: "flex",
      flexDirection: "column",
      height: "100%",
      minHeight: "30vw",
      justifyContent: "center",
      margin: props.isProductLine
        ? theme.spacing(0, 2, 0, 8)
        : theme.spacing(0, 8),
      padding: theme.spacing(4, 1),
      textAlign: "left",
      [theme.breakpoints.down("md")]: {
        alignItems: "center",
        margin: 0,
      },
    }),
    copyText: props => ({
      marginBottom: 32,
      lineHeight: props.isProductLine ? "32px" : "unset",
      [theme.breakpoints.down("md")]: {
        textAlign: "center",
        lineHeight: "40px",
        fontSize: theme.spacing(3.5),
      },
    }),
    staticCopyText: {
      marginBottom: 32,
      [theme.breakpoints.down("md")]: {
        textAlign: "center",
        padding: theme.spacing(0, 4),
      },
      [theme.breakpoints.between("md", "lg")]: {
        fontSize: theme.spacing(2),
      },
    },
    titleText: props => ({
      marginBottom: 32,
      [theme.breakpoints.down("md")]: {
        textAlign: "center",
      },
      color: `${
        props.color
          ? theme.palette[props.color] && theme.palette[props.color].main
            ? theme.palette[props.color].main
            : theme.palette.green.main
          : props.color
      }`,
    }),
    staticTitleText: props => ({
      marginBottom: 32,
      [theme.breakpoints.down("md")]: {
        textAlign: "center",
      },
      color: `${
        props.color
          ? theme.palette[props.color] && theme.palette[props.color].main
            ? theme.palette[props.color].main
            : theme.palette.green.main
          : props.color
      }`,
      [theme.breakpoints.between("md", "lg")]: {
        fontSize: theme.spacing(4),
        marginTop: theme.spacing(3),
      },
    }),

    imageWrapper: {
      alignItems: "stretch",
      position: "relative",
      height: "100%",
      maxHeight: 640,
      "& img": {
        objectFit: "cover",
      },
      "& video": {
        objectFit: "cover",
      },
      [theme.breakpoints.down("md")]: {
        position: "relative",
        height: "100%",
        width: "100%",
      },
    },
    productLineBanner: {
      [theme.breakpoints.up("lg")]: {
        marginLeft: props => (props.mediaPosition === "Left" ? "0px" : "100px"),
      },

      alignItems: "stretch",
      height: "100%",
      "& img": {
        objectFit: "cover",
      },
      [theme.breakpoints.down("md")]: {
        marginLeft: "0px",
        height: "100%",
        position: "relative",
        width: "100%",
      },
    },
    image: {
      height: "100%",
      objectFit: "cover",
      width: "100%",
    },
    firstImageGrid: {
      [theme.breakpoints.up("lg")]: {
        display: "none",
      },
    },
    secondImageGrid: {
      [theme.breakpoints.down("md")]: {
        display: "none",
      },
    },
  }
})

export default props => {
  const classes = useStyles(props)
  return (
    <div className={classes.root}>
      <Grid
        xs={0}
        container
        noMaxWidth
        noMargins
        wrapReverse
        className={classes.grid}
      >
        <Grid
          item
          xs={8}
          lg={props.static ? 6 : 7}
          className={classes.firstImageGrid}
        >
          <div
            className={
              props.isProductLine
                ? classes.productLineBanner
                : classes.imageWrapper
            }
          >
            {props.mediaType === "Video" && (
              <video
                src={props.videoSrc}
                width="100%"
                height="100%"
                preload="auto"
                loop
                autoPlay
                muted
              />
            )}
            {props.mediaType === "Image" &&
              (props.webp ? (
                <Img
                  className={classes.image}
                  fluid={props.imageSrc}
                  alt={""}
                />
              ) : (
                <img src={props.staticImg} alt={""} className={classes.image} />
              ))}
          </div>
        </Grid>
        <Grid item xs={8} lg={props.static ? 6 : 5}>
          <div className={classes.copy}>
            {props.static && (
              <Typography
                className={
                  props.static ? classes.staticTitleText : classes.titleText
                }
              >
                {props.titleText && <RichTitle titleText={props.titleText} />}
              </Typography>
            )}
            <Typography
              className={
                props.static ? classes.staticCopyText : classes.copyText
              }
            >
              {props.copyText && <RichDescription copyText={props.copyText} />}
            </Typography>
          </div>
        </Grid>
        <Grid
          item
          xs={4}
          lg={props.static ? 6 : 7}
          className={classes.secondImageGrid}
        >
          <div
            className={
              props.isProductLine
                ? classes.productLineBanner
                : classes.imageWrapper
            }
          >
            {props.mediaType === "Video" && (
              <video
                src={props.videoSrc}
                width="100%"
                height="100%"
                preload="auto"
                loop
                autoPlay
                muted
              />
            )}
            {props.mediaType === "Image" &&
              (props.webp ? (
                <Img
                  className={classes.image}
                  fluid={props.imageSrc}
                  alt={""}
                />
              ) : (
                <img src={props.staticImg} alt={""} className={classes.image} />
              ))}
          </div>
        </Grid>
      </Grid>
    </div>
  )
}
